import { render, staticRenderFns } from "./purchaser.vue?vue&type=template&id=9dcf8a2e"
import script from "./purchaser.vue?vue&type=script&lang=js"
export * from "./purchaser.vue?vue&type=script&lang=js"
import style0 from "./purchaser.vue?vue&type=style&index=0&id=9dcf8a2e&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/wwwroot/check/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9dcf8a2e')) {
      api.createRecord('9dcf8a2e', component.options)
    } else {
      api.reload('9dcf8a2e', component.options)
    }
    module.hot.accept("./purchaser.vue?vue&type=template&id=9dcf8a2e", function () {
      api.rerender('9dcf8a2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaser/purchaser.vue"
export default component.exports